// Library Imports
import * as React from "react";
import { Grid, InputLabel, Switch, TextField, MenuItem, FormControl, Select } from "@mui/material";

// helper imports
import { snakeCaseToTitleCase } from "../utils/CaseFormatHelper";

// header import
import { getHeaders } from "../utils/HeaderHelper";

// app setting imports
import { AuthenticationContext } from "../Context";
import CustomDatePicker from "../common/CustomDatePicker";
import moment from "moment";
import { useFlash } from "../FlashContext";

interface Props {
  generateClaim: boolean;
  setGenerateClaim: any;
  encounterType: string;
  setEncounterType: any;
  dayOfEncounter: string;
  setDayOfEncounter: any;
  placeOfService: string;
  placeOfServiceList: any;
  setPlaceOfService: any;
  encounterTypeOptions: any;
  readOnly: boolean;
  setMedicationProblems: any;
}

const EncounterInformationPanel: React.FC<Props> = (props: any) => {
  // authentication context
  const authenticationSetting = React.useContext(AuthenticationContext);
  const placeOfServiceOptions = props.placeOfServiceList;
  const { showToast } = useFlash();

  React.useEffect(() => {
    checkExistingBillingRecords();
  }, []);

  const getEncounterId = () => {
    const url_string = window.location.href;
    const url = new URL(url_string);
    return url.searchParams.get("encounter_id");
  };

  const checkExistingBillingRecords = () => {
    const encounterId = getEncounterId();
    if (encounterId) {
      fetch(`/encounters/encounter_information_panel_data/${encounterId}`, {
        method: "GET",
        headers: getHeaders(authenticationSetting.csrfToken),
      })
        .then((result) => result.json())
        .then((result) => {
          if (result.success == false) {
            showToast({ 
              title: "Encounter Information Load Error", 
              text: result.error || "Failed to retrieve encounter information.", 
              type: "error" 
            });
          } else {
            const encounterBilling = result?.resource;
            console.log('encounterBilling')
            console.log(encounterBilling)
            props.setGenerateClaim(encounterBilling?.generate_claim);
            props.setEncounterType(encounterBilling?.encounter_type);
            props.setDayOfEncounter(encounterBilling?.db_date_string);
            props.setPlaceOfService(encounterBilling?.place_of_service);
            props.setMedicationProblems(encounterBilling?.medication_problems?.map((item, index) => ({ ...item, key: index + 1 })) || [])
          }
        })
        .catch((error) => {
          showToast({ 
            title: "Encounter Information Load Error", 
            text: error.message || "Failed to retrieve encounter information.", 
            type: "error" 
          });
        });
    }
  };

  const handleDateChange = (date) => {
    props.setDayOfEncounter(date);
  };

  const encounterTypes = props.encounterTypeOptions.map((type) => {
    return (
      <MenuItem key={type[0]} value={type[0]}>
        {
          type[0] === "diabetes_management" ?
            "NDPERS Diabetes Program" :
            snakeCaseToTitleCase(type[0])
        }
      </MenuItem>
    );
  });

  return (
    <Grid container item xs={12} className="single-panel">
      <Grid item xs={12}>
        <Grid container direction="row" className="admin-header">
          <Grid item xs={12} lg={6}>
            <h3>Encounter Information</h3>
          </Grid>
        </Grid>
        <Grid container className="form-body" spacing={1}>
          {/* <Grid container item xs={2}>
            <Grid item xs={12}>
              <InputLabel htmlFor="generate_claim" className="field-label">
                Generate Claim?
              </InputLabel>
            </Grid>
            <Grid item xs={12} className="field-container">
              <span className="grey-font">No</span>
              <Switch
                checked={props.generateClaim}
                onChange={handleSwitchChange}
                color="primary"
              />
              <span className="grey-font">Yes</span>
            </Grid>
          </Grid> */}
          <Grid container item xs={4}>
            <Grid item xs={12}>
              <CustomDatePicker
                id={"date-picker-inline"}
                label={"Date of Encounter"}
                placeholder={"Select Date of Encounter"}
                date={moment(props.dayOfEncounter)}
                handleDateChange={handleDateChange}
                disabled={props.readOnly}
              />
            </Grid>
          </Grid>
          <Grid container item xs={4}>
            <Grid item xs={12}>
              <InputLabel htmlFor="encounter_type" className="field-label">
                Encounter Type
              </InputLabel>
            </Grid>
            <Grid item xs={12} className="field-container">
              <TextField
                id="encounter_type"
                size="small"
                value={props.encounterType}
                className="field w-100"
                required
                variant="outlined"
                onChange={(event) => {
                  props.setEncounterType(event.target.value);
                }}
                select
                disabled={true}
              >
                {encounterTypes}
              </TextField>
            </Grid>
          </Grid>
          <Grid container item xs={4}>
            <Grid item xs={12}>
              <InputLabel htmlFor="place_of_service" className="field-label">
                Place of Service*
              </InputLabel>
            </Grid>
            <Grid item xs={12} className="field-container">
              <TextField
                id="place_of_service"
                size="small"
                value={props.placeOfService || "Select Place of Service"}
                className="field w-100"
                required
                variant="outlined"
                onChange={(event) => {
                  props.setPlaceOfService(event.target.value);
                }}
                select
                disabled={props.readOnly}
              >
                <MenuItem value="Select Place of Service" disabled>
                  Select Place of Service
                </MenuItem>

                {placeOfServiceOptions.map((option) => (
                  <MenuItem key={option.code} value={`${option.code} - ${option.name}`}>
                    {`${option.code} - ${option.name}`}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EncounterInformationPanel;
